/** @type import("shared/react").Metadata */
export const config = {
	language: "en",
	base: "https://trajectory.fit",
	site: "Trajectory",
	meta: {
		"mobile-web-app-capable": true,
		"apple-mobile-web-app-capable": true,
		"apple-mobile-web-app-title": "Trajectory",
		"apple-mobile-web-app-status-bar-style": "black-translucent",
		"accept-ch": "Sec-CH-DPR, Sec-CH-Width, Sec-CH-Viewport-Width",
	},
	links: {
		"manifest": "/manifest.json",
		"icon": "/img/favicon_512.png",
		"apple-touch-icon": "/img/icon_512.png",
	},
	csp: {
		"default-src": ["'self'"],
		"connect-src": ["'self'", "gap:", "https://ssl.gstatic.com", "https://*.googleapis.com", "https://us-east4-trajectory-fit-production.cloudfunctions.net"],
		"script-src": ["'self'", "https://apis.google.com"],
		"style-src": ["'self'", "'unsafe-inline'"],
		"frame-src": ["'self'", "https://trajectory-fit-production.firebaseapp.com/"],
		"img-src": ["'self'", "data:", "https://ik.imagekit.io/trajectory/"],
		"media-src": ["'self'"],
	},
};
